module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/name/prefix.js
 ** module id = 1006
 ** module chunks = 0
 **/